export const makeLabelRequired = (text: string) => {
  return (
    <>
      {text} <span className={'h-color-R100'}>*</span>
    </>
  );
};
